import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    ref,
} from '@vue/composition-api';

import { AuthenticationStore } from '@store/modules/data/authentication/authenticationIndex';
import { errorGuard } from '@core/utils/ErrorGuard';

export function useResponsibleGaming() {
    const isLoadingLimits = ref<boolean>(false);
    const defaultRealityCheckPeriod = 60;
    const authenticationStore = useVuexStore<AuthenticationStore>('data/authentication');

    const getLimits = authenticationStore.action('getLimits');
    const fetchRealityCheckPeriod = authenticationStore.action('fetchRealityCheckPeriod');

    async function fetchLimitData() {
        isLoadingLimits.value = true;
        await errorGuard(() => getLimits());
        isLoadingLimits.value = false;
    }

    fetchLimitData();
    fetchRealityCheckPeriod();

    return {
        defaultRealityCheckPeriod,
        depositLimits: authenticationStore.getter('depositLimits'),
        bettingLimits: authenticationStore.getter('totalWagerLimits'),
        lossLimits: authenticationStore.getter('lossLimits'),
        sessionLimits: authenticationStore.getter('sessionLimits'),
        realityCheckPeriod: computed(() => authenticationStore.getter('realityCheckPeriod').value || defaultRealityCheckPeriod),
        setLimits: authenticationStore.action('setLimits'),
        cancelLimits: authenticationStore.action('cancelLimits'),
        setRealityCheckPeriod: authenticationStore.action('setRealityCheckPeriod'),
        selfExclude: authenticationStore.action('selfExclude'),
        timeOut: authenticationStore.action('timeOut'),
        closeAccount: authenticationStore.action('closeAccount'),
        closeAccountMfa: authenticationStore.action('closeAccountMfa'),
        refreshLimits: getLimits,
        isLoadingLimits,
    };
}
